export default class FilterAttributes {

  public id
  public title
  public type
  public data

}